import { useAddGiftCardLineMutation, GetGiftCardInfoQueryKey } from 'autogen/swagger/all/hooks';
import { AddGiftCard } from 'autogen/translation-keys/trans-website-checkout-giftcard';
import { Button } from 'components/Button';
import { useTranslation } from 'react-i18next';
import queryClient from 'setup/react-query/queryClient';

export default function AddGiftCardLineButton() {
    const { t } = useTranslation();
    const { mutateAsync: addGiftCardLine } = useAddGiftCardLineMutation({
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [GetGiftCardInfoQueryKey] });
        }
    });

    return (
        <Button variant="primaryText" type="button" onClick={() => addGiftCardLine({})}>
            {t(AddGiftCard)}
        </Button>
    );
}
